import { FORGOT_PASSWORD_PREFIX, LOGIN_PREFIX } from 'constants';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { useNavigate } from 'react-router-dom';
import AccountWithEmailExistInformPopup from './popup';

const AccountWithEmailExistInformModal = ({ isShow }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate(LOGIN_PREFIX);
    closePortalModalName();
  };

  const handleOnClose = () => {
    navigate(FORGOT_PASSWORD_PREFIX);
    closePortalModalName();
  };

  return (
    <AccountWithEmailExistInformPopup
      isOpen={isShow}
      buttonLabel1={t('button_forgot_password')}
      onClose={handleOnClose}
      buttonLabel2={t('button_login')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default AccountWithEmailExistInformModal;
